import React from 'react';
import './PrivacyPolicy.css';
import notFoundImage from '../../assets/error404.svg';
import { useTranslation } from 'react-i18next';

const NotFound = () => {
  const { t } = useTranslation();
  return (
    <>
      <div className="not-found-container">
        <div className="not-found-content">
          <img src={notFoundImage} alt="Not Found" className="not-found-image" />
          <h1 className="not-found-title">404</h1>
          <p className="not-found-message">
            {t('custom.no-data-page')}
          </p>
          <a href="/" className="not-found-home-link">
            {t('custom.return-home')}
          </a>
        </div>
      </div>

    </>
  );
};

export default NotFound;
